import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	

});
const Inputs = [
	{
		name: 'key',
		label: 'Key',
		type: 'text',
		value: 'single',
		valueAttr: 'key',
	},
	{
		name: 'translartions',
		label: 'Translations',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'translartions',
		columns: [
			{
				name: 'languageCode',
				label: 'Language',
				type: 'text',
				required: true,
			},
			{
				name: 'translatedName',
				label: 'Translated Name',
				type: 'text',
				required: true,
			}
		]
	}

];

export { Inputs, validationSchema };
